import { Divider, DividerProps } from 'antd';

const zeroMarginStyle = { marginTop: 0, marginBottom: 0 };
interface Props {
    antdProps?: DividerProps;
    zeroMargin?: boolean;
}
export default function CustomDivider({ antdProps, zeroMargin = false }: Props) {
    return <Divider style={zeroMargin ? zeroMarginStyle : {}} {...antdProps} />;
}
